import React from "react";
import Sidebar from "../../../../partials/aside/Sidebar";
import TitleBar from "../../../../partials/content/TitleBar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";

export default function Add() {
  const params = useParams();
  const history = useHistory();
  const userID = params.userID;

  const sendForm = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddNoteCall = await sendRequestAddNoteCall({
      user_id: userID,
      title: document.querySelector("#title").value,
      text: document.querySelector("#text").value,
    });
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestAddNoteCall) {
      return;
    }
    history.push(`/user/manage/${userID}/note-call`);
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestAddNoteCall = async (dataForm) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/note-call",
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن یادادشت تماس با کاربر" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  sendForm();
                }}
              >
                <div className="form-group">
                  <label>عنوان</label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>متن</label>
                  <textarea
                    className="form-control"
                    id="text"
                    rows="10"
                    required
                  ></textarea>
                </div>
                <button className="btn btn-success">اضافه کردن</button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
